import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import geolib from 'geolib'
import GoogleMapReact from 'google-map-react'
import { SEARCH, SearchContext } from '../search/SearchContext'
import { mapStyles } from './map.config'
import MapMarker from './MapMarker'

const MapView = ({ center, zoom, height }) => {
  const {
    state: {
      currentHotels,
      visibleHotels,
      hoveredHotel,
      hotels,
      meta,
      hotel: currentHotel
    },
    dispatch,
  } = useContext(SearchContext)

  const _setVisibleHotels = (visibleHotels) =>
    dispatch({ type: SEARCH.VISIBLE_HOTELS.SET, payload: visibleHotels })
  const _setHotel = (hotel) =>
    dispatch({ type: SEARCH.HOTEL.SET, payload: hotel })
  const _setRoom = (room) => dispatch({ type: SEARCH.ROOM.SET, payload: room })
  const _setPopUpOpen = (open) => dispatch({ type: SEARCH.POP_UP_OPEN.SET, payload: open })
  const [map, setMap]       = useState()
  const [maps, setMaps]     = useState()
  const [mapHeight, setMapHeight] = useState("calc(100% - 45px)")

  useEffect(() => {
    if(map && maps)
      reDrawBounds(map, maps, currentHotels)
  }, [currentHotels])

  const _mapChangeHandler = ({ nw, ne, se, sw }, prevState) => {
    const nextState = []

    prevState.forEach((r) => {
      if(isNaN(r.latitude) || isNaN(r.longitude)) return
      let point = { latitude: r.latitude, longitude: r.longitude }
      let bounds = [
        { latitude: nw.lat, longitude: nw.lng },
        { latitude: ne.lat, longitude: ne.lng },
        { latitude: se.lat, longitude: se.lng },
        { latitude: sw.lat, longitude: sw.lng },
      ]
      try {
        if (geolib.isPointInside(point, bounds)) nextState.push(r)
      } catch (e) {
        console.error('in catch: ', e, r) //eslint-disable-line
      }
    })
    _setVisibleHotels(nextState)
  }

  // Re-center map when resizing the window
  const bindResizeListener = (map, maps, bounds) => {
    maps.event.addDomListenerOnce(map, 'idle', () => {
      maps.event.addDomListener(window, 'resize', () => {
        map.fitBounds(bounds)
        setMapHeight("calc(100% - 50px)")
      })
    })
  }

  // Fit map to its bounds after the api is loaded
  const apiIsLoaded = (map, maps, hotels) => {
    // Set Map Visible
    _setMapVisible()
    setMap(map)
    setMaps(maps)
    let bounds = reDrawBounds(map, maps, hotels)
    // Bind the resize listener
    bindResizeListener(map, maps, bounds)
  }

  const reDrawBounds = (map, maps, hotels) => {
    // Get bounds by our places
    const bounds = getMapBounds(map, maps, hotels)
    // Fit map to bounds
    map.fitBounds(bounds, { top: 30, right: 10, left: 100, bottom: 30 })
    return bounds
  }

  const _setMapVisible = () => {
    const $mapView = document.querySelector("#map-view")
    $mapView.style.visibility = "visible"
  }

  // Return map bounds based on list of places
  const getMapBounds = (map, maps, places) => {
    const bounds = new maps.LatLngBounds()

    places.forEach((place) => {
      try {
        if (
          !isNaN(place.latitude) &&
          !isNaN(place.longitude) &&
          place.latitude > -90 &&
          place.latitude < 90 &&
          place.longitude > -180 &&
          place.longitude < 180
        ) {
          bounds.extend(new maps.LatLng(place.latitude, place.longitude))
        }
      } catch (e) {
        console.error(e, hotel) //eslint-disable-line
      }
    })

    return bounds
  }

  const _checkActive = id => hoveredHotel && hoveredHotel === id
  const _checkCurrent = id => currentHotel && currentHotel.id === id

  const renderMapMarker = (hotel) => {
    try {
      if (
        hotel &&
        !isNaN(hotel.latitude) &&
        !isNaN(hotel.longitude) &&
        hotel.latitude > -90 &&
        hotel.latitude < 90 &&
        hotel.longitude > -180 &&
        hotel.longitude < 180
      ) {
        return (
          <MapMarker
            key           = {hotel.id}
            lat           = {hotel.latitude}
            lng           = {hotel.longitude}
            hotel         = {hotel}
            setHotel      = {_setHotel}
            setRoom       = {_setRoom}
            setPopUpOpen  = {_setPopUpOpen}
            active        = {_checkActive(hotel.id)}
            current       = {_checkCurrent(hotel.id)}
          />
        )
      } else {
        return null
      }
    } catch(e) {
      console.error(e) // eslint-disable-line
      return null
    }
  }

  const _displayResultsBar = () => (
    <div className="filter toolbar">
      <h2>
        <span>Map View</span>
        <small>Showing {visibleHotels.length} of {meta && meta.total_count} hotels</small>
      </h2>
    </div>
  )

  return (
    <div
      id="map-view"
      style={{ height: height, width: '100%' }}
      className={`map-view`}
      >
      { _displayResultsBar()}
      <div className="map-wrapper" style={{width: "100%", height: mapHeight}}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyDhSxv2iFLDxZ3J4nbQJdpc05k1FK2V_GU' }}
          center={center}
          defaultZoom={zoom}
          styles={mapStyles}
          onChange={({ bounds }) => _mapChangeHandler(bounds, currentHotels)}
          yesIWantToUseGoogleMapApiInternals={true}
          onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps, currentHotels)}
        >
          {currentHotels.map((hotel) => {
            return renderMapMarker(hotel)
          })}
        </GoogleMapReact>
      </div>
    </div>
  )
}

MapView.defaultProps = {
  center: {
    lat: 36.114647,
    lng: -115.172813,
  },
  height: '100vh',
  zoom: 11,
  overviewMapControl: false,
  streetViewControl: false,
  rotateControl: true,
  mapTypeControl: false,
}

MapView.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  zoom: PropTypes.number.isRequired,
  height: PropTypes.string,
}

export default MapView
